import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";
import { useApi } from "@/lib/api/useApi";
import { api } from "@/lib/api/client";
import { Loader2 } from "lucide-react";

export function SizeGuideModal({ open, onOpenChange, sizeGuideId }: { open: boolean; onOpenChange: (open: boolean) => void; sizeGuideId: string | null }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const { data, loading } = useApi(
    ["size-guides"],
    async () => {
      const res = await api<any[]>("/catalog/size-guides");
      return res || [];
    }
  );

  const guide = sizeGuideId && data ? data.find((g: any) => g.id === sizeGuideId) : null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl bg-surface">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-on-surface">
            {t("product.sizeGuide") || "Size Guide"}
          </DialogTitle>
        </DialogHeader>

        {!sizeGuideId ? (
          <div className="py-8 text-center text-muted-foreground">No size guide available for this product.</div>
        ) : loading ? (
          <div className="py-12 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>
        ) : !guide ? (
          <div className="py-8 text-center text-muted-foreground">Size guide not found.</div>
        ) : (
          <div className="space-y-6">
            <h3 className="text-lg font-semibold">{lang === 'ar' ? guide.name_ar : guide.name_en}</h3>
            
            {guide.image_url && (
              <img src={guide.image_url} alt="Size Guide" className="w-full h-auto rounded border border-border" />
            )}

            {guide.rows && guide.rows.length > 0 && (
              <div className="overflow-x-auto border border-border rounded-lg">
                <table className="w-full text-sm text-left">
                  <thead className="bg-surface-container-low text-on-surface">
                    <tr>
                      {Object.keys(guide.rows[0]).map((col) => (
                        <th key={col} className="px-4 py-3 font-medium uppercase tracking-wider">{col}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-border">
                    {guide.rows.map((row: any, i: number) => (
                      <tr key={i} className="hover:bg-surface-container-low/50">
                        {Object.values(row).map((val: any, j: number) => (
                          <td key={j} className="px-4 py-3">{val}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
